import { call, put, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import {
    deactivateAccountSuccess,
    deactivateAccountFailure,
} from '../../actions/authActions/deactivateAccountActions';

function* deactivateAccount({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.deactivateAccount,
            payload: payload,
            isAuth: true,
        });
        yield put(
            deactivateAccountSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message,
            })
        );
        if (callback) {
            callback(response?.data?.response, response?.data?.status, response?.data?.message);
        }
    } catch (error) {
        console.log('DEACTIVATE_ACCOUNT_FAILURE:', error?.response?.data);
        const errorData = error?.response?.data || {};
        yield put(
            deactivateAccountFailure({
                status: errorData.status || 500,
                response: {},
                message: errorData.message || 'Something went wrong',
            })
        );
        if (callback) {
            callback(null, errorData.status || 500, errorData.message || 'Something went wrong');
        }
    }
}

function* deactivateAccountSaga() {
    yield takeLatest(actionTypes.DEACTIVATE_ACCOUNT_REQUEST, deactivateAccount);
}

export default deactivateAccountSaga;
